import { createPortal } from 'react-dom';

/**
 * ModalPortal - Rend les modales directement dans document.body
 * Cela permet d'éviter les problèmes de positionnement causés par
 * les propriétés CSS comme `transform` qui créent un nouveau contexte de positionnement.
 */
function ModalPortal({ children }) {
  return createPortal(children, document.body);
}

export default ModalPortal;
